import { NextPage } from "next";
import Head from "next/head";
import { TextBlockWithTitle } from "../components/TextBlockWithTitle";
import { PageLayout, PageTypes } from "../layouts/page";
import { Text } from "./terms-of-service";

const PrivacyPolicy: NextPage = () => {
  return (
    <>
      <Head>
        <title>Privacy Policy</title>
      </Head>
      <PageLayout showAccents pageType={PageTypes.NARROW}>
        <TextBlockWithTitle title={"Privacy Policy"}>
          <Text>
            This Privacy Policy sets forth VAULT’s (“we”, “our” or “us”)
            policies and procedures regarding the collection, use, and
            disclosure of your information in connection with your use of the
            VAULT application (the “App”) and any associated services, features,
            content, or applications we offer through the App (collectively, the
            “Services”). We receive information about you from various sources,
            including: (i) when&nbsp; you register for the App or the Services,
            through your user Account (your “Account”); (ii) your use of the
            Services; and (iii) from third-party websites and services, such as
            social media companies. When you use the Services, you agree to the
            collection, use, and disclosure of your information as described in
            this Privacy Policy.&nbsp;&nbsp;
            <br />‍<br />
            <strong>What Does This Privacy Policy Cover?</strong>
            <br />
            This Privacy Policy explains the treatment of personally
            identifiable information (“Personal Information”) gathered when you
            are using or accessing the Services. This Privacy Policy also covers
            our treatment of any Personal Information that our Business Partners
            share with us or that we share with our Business
            Partners.&nbsp;&nbsp;
            <br />
            <br />
            This Privacy Policy only covers our use of Your information. It does
            not apply to the practices of third parties that we do not own or
            control, such as any third party websites, services and applications
            (e.g. Twitch, YouTube, Google, Twitter, Facebook, Instagram, etc.)
            (each a “Third Party Service”) that you you may make use of when
            using the Service. We cannot take responsibility for the content or
            privacy policies of those Third Party Services, please review those
            services’ policies carefully.
            <br />
            <br />
            <strong>What Information Do We Collect and Use?</strong>
            <br />
            We collect information to personalize, improve, protect, and
            continue to operate the Services. We may request, collect and/or
            display some of your Personal Information. We collect the following
            types of information from our users.
            <br />‍<br />
            Account Information:If you create an Account on the Services
            (“Account”), you may be required to provide information that could
            be Personal Information, such as your name, phone number and/or
            email address. You may be asked to supplement this information with
            additional information to collect prizes or participate in certain
            contests. If you register for or access the Services using a Third
            Party Service (such as your social media account login credentials),
            we may receive Personal Information that you allow such Third Party
            Service to share with us. You acknowledge that the information we
            receive may be personal to you, and by creating an Account and
            providing Personal Information to us, you allow others, including
            us, to identify you. We may use your contact information to send you
            information about our Services. You may unsubscribe from some of
            these messages by emailing us at support@vault.fan, although we,
            regardless, reserve the right to contact you when we believe it is
            necessary, such as for Account recovery purposes.
            <br />‍<br />
            Information Regarding Third Party Services:
            <br />
            You may interact with third party applications while using the
            Service (“Third Party Service”).&nbsp; By interacting with or using
            these Third Party Services, your interactions with those Third Party
            Services, are subject to the Third Party Service’s privacy policy.
            Therefore, we encourage you to read the privacy policies and other
            policies of any Third Party Services, including any applicable
            social networks, you use while using our Services.Additionally, we
            may collect and receive your social media account login credentials
            to provide you with the Services, but only if you expressly provide
            us with such information. We will only use such login information as
            outlined in this Privacy Policy or as otherwise expressly authorized
            by you.
            <br />
            <br />
            Personal Information Retention:
            <br />
            We keep your information for no longer than necessary for the
            purposes for which it is processed. The length of time for which we
            retain information depends on the purposes for which we collected
            and use it and/or as required to comply with applicable laws.&nbsp;
            Information may persist in copies made for backup and business
            continuity purposes for longer than we keep the original data.
            <br />
            Location Information:
            <br />
            Some of our Services may include features based on users’ actual
            locations and may report on users’ current locations, and may
            require you to use location services to access a contest or portion
            of the Service (“Location-Based Services”).&nbsp; To the extent you
            opt to use any Location-Based Services, we may collect and store
            information about your location at the time you use those
            Location-Based Services. Additionally, we may also collect and/or
            receive location information from your use of the Services
            generally.
            <br />‍<br />
            IP Address Information and Other Information Collected
            Automatically:
            <br />
            We automatically collect usage information, such as the number and
            frequency of visitors to the App and users of the Services. We may
            use this data in aggregate form, that is, as a statistical measure,
            or in other anonymous forms, but not in a manner that would identify
            you personally. This type of data enables us, and third parties
            authorized by us, to figure out how often individuals use parts of
            the Services.
            <br />
            <br />
            We may collect some device-specific information if you access the
            Services using a mobile device.&nbsp; Device information may include
            but is not limited to unique device identifiers, network
            information, and hardware model, as well as information about how
            the device interacts with our Services.We may use this information
            for advertising, analytics or the other purposes described in this
            Privacy Policy.&nbsp; If you do not want to receive behavioural
            in-application advertisements from third parties that relate to your
            interests on your mobile device, you may adjust the ad tracking
            settings on your device (such as turning on “Limit Ad
            Tracking”).&nbsp; You can also reset the “Advertising Identifier”
            (such as an IDFA) from your mobile device’s settings pages, which
            will prevent continued use of existing behavioural data tied to your
            previous “Advertising Identifier.”&nbsp; Further, you may be able to
            download third-party apps, such as the Digital Advertising
            Alliance’s “AppChoices” app, that offer to provide you with control
            regarding the collection and use of cross-app data for behavioural
            advertising.
            <br />
            <br />
            Email, Text, and Push Notification Communications:
            <br />
            We may communicate with you via push notification, email, SMS, MMS
            or other text message (“Message”) (to the extent you permit us to do
            so), and we may collect information regarding such communications,
            such as confirmation when you open an email, read a Message or
            receive a push notification. We use this information to improve our
            Services, including our customer service.&nbsp;&nbsp;
            <br />‍<br />
            Aggregate Information:
            <br />
            We collect statistical information about how both unregistered and
            registered users, use the Services (“Aggregate Information”). Some
            of this information is derived from Personal Information. This
            statistical information is not Personal Information and cannot be
            tied back to you, your Account or your web browser.
            <br />
            <br />
            Children’s Privacy:
            <br />
            We do not knowingly collect or solicit personal information from
            anyone under the age of 13 or knowingly allow such persons to
            register. If we become aware that we have collected personal
            information from a child under the relevant age without parental
            consent, we take steps to delete that information.
            <br />
            <br />
            <strong>HOW IS MY INFORMATION USED AND SHARED?</strong>
            <br />
            <br />
            Public Information About Your Activity on the Services:Some of your
            activity on and through the Services is public. Public activity may
            include, content you have posted publicly on, through or in
            connection with the Services, including public portions of Third
            Party Services, such as your social media accounts. Registered users
            may have some of this information associated with their Accounts.
            Unregistered users will not have this association, but we may track
            and store information concerning their use of the Services (such as
            interactions within our mobile App) anonymously. Please remember
            that if you provide Personal Information using certain public
            features of the Services, then that information is governed by the
            privacy settings of those particular features and may be publicly
            available. Individuals reading such information may use or disclose
            it to other individuals or entities without our control and your
            knowledge, and search engines may index that information. We urge
            you to think carefully about including any specific information you
            may deem private in content that you create or information that you
            submit through the Services.
            <br />‍<br />
            IP Address and Device Information:
            <br />
            While we may collect and store IP address and device information,
            that information is not made public. We do at times, however, share
            this information with our partners, service providers and other
            persons with whom we conduct business, and as otherwise specified in
            this Privacy Policy.
            <br />‍<br />
            Information You Elect to Share:
            <br />
            You may access other Third Party Services through the Services, for
            example by clicking on links to those Third Party Services from
            within our Services. We are not responsible for the privacy policies
            and/or practices of these Third Party Services, and you are
            responsible for reading and understanding those Third Party
            Services’ privacy policies. This Privacy Policy only governs
            information collected on the Services.
            <br />
            <br />
            Aggregate and Non-Personally Identifiable Information:
            <br />
            We share Aggregate Information with our partners, service providers
            and other persons with whom we conduct business, such as social
            networks (“Business Partners”).&nbsp; We may also share information
            with our Business Partners that is (i) not Personal Information or
            (ii) derived from Personal Information but has been anonymized so
            that it is no longer personally identifiable (collectively with
            Aggregate Information, “Non-Personal Information”). We use and share
            this type of data so that our Business Partners and we can
            understand how and how often people use our and their services or
            websites, which facilitates improving our Services, their services
            and how our Services interface with their services. These Business
            Partners may also share with us non-private, aggregated or otherwise
            non-Personal Information about you that they have independently
            developed or acquired.
            <br />‍<br />
            Email and SMS Communications with Us:
            <br />
            As part of the Services, you may occasionally receive push
            notifications, email, SMS text and other communications from us,
            such as communications relating to your Account.
            <br />‍<br />
            User Profile Information:
            <br />
            User profile information including your username and other
            information you enter may be displayed to other users to facilitate
            user interaction within the Services. We will not directly reveal
            user email addresses to other users.
            <br />
            Social Media Account Login Credentials:
            <br />
            If you share your Third Party Services account login credentials
            with us, we may use such information to post on your behalf.&nbsp;
            We will never share or disclose your login credentials outside of
            our company.&nbsp; We may share your User Content (as defined in the{" "}
            <a href="/terms-of-service">Terms of Service</a>
            ), or some derivative of it, on our company-branded social media
            channels, and we may tag you in such post using your name, social
            media name, handle or other identifier.
            <br />
            Information Shared with Our Agents:
            <br />
            We employ and contract with people and other entities that perform
            certain tasks on our behalf and who are under our control (our
            “Agents”). We may need to share Personal Information with our Agents
            to provide products or services to you. Unless we tell you
            differently, our Agents do not have any right to use Personal
            Information or other information we share with them beyond what is
            necessary to assist us. You hereby consent to our sharing of
            Personal Information with our Agents.
            <br />‍<br />
            Information Disclosed When Transferring the Business:In some cases,
            we may choose to buy or sell assets. In these types of transactions,
            user information is typically one of the transferred business
            assets. Moreover, if we, or substantially our assets, were acquired,
            or if we go out of business or enter bankruptcy, user information
            would be one of the assets that are transferred or acquired by a
            third party. You acknowledge that such transfers may occur and that
            any acquirer of us or our assets may continue to use your Personal
            Information as outlined in this policy.
            <br />‍<br />
            Information Handling Generally
            <br />
            In addition to collecting and handling Personal Information for the
            purposes described above, we may access, retain, use and disclose
            the information we collect and maintain about you if required to do
            so by law or in a good faith belief that such access, retention, use
            or disclosure is reasonably necessary to: (a) comply with legal
            process (e.g. a subpoena or court order); (b) enforce our{" "}
            <a href="/terms-of-service">Terms of Service</a> or other contracts
            with you, or this Privacy Policy, including investigation of
            potential violations thereof; (c) respond to claims that any content
            violates the rights of third parties; (d) respond to your requests
            for customer service; and/or (e) protect the rights, property or
            personal safety of VAULT, its agents and affiliates, its users
            and/or the public. This includes exchanging information with other
            companies and organizations for fraud protection, and spam/malware
            prevention, and similar purposes.&nbsp; We also use and disclose
            Personal Information to conduct research, improve our Services, and
            engage in marketing and other communications.&nbsp;&nbsp;
            <br />
            <br />
            Legal Basis for Processing Business Data
            <br />
            The laws in some jurisdictions require companies to tell you about
            the legal ground they rely on to use or disclose your personal data.
            To the extent those laws apply, our legal grounds for processing
            Personal Information are as follows:
            <br />‍<br />- To honor our contractual commitments to you: Much of
            our processing of Personal Information is to meet our contractual
            obligations to our users, or to take steps at users’ request in
            anticipation of entering into a contract with them.
            <br />- Consent: Where required by law, and in some other cases, we
            handle Personal Information on the basis of consent.
            <br />- Legitimate interests: In many cases, we handle personal data
            on the ground that it furthers our legitimate interests in
            commercial activities such as the following in ways that are not
            overridden by the interests or fundamental rights and freedoms of
            the affected individuals:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />‍<br />- Providing our
            Services&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />- Marketing&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />- Protecting our users, personnel and
            property&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />- Analyzing and improving our
            business&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />- Managing risks and legal issues
            <br />- We may also process personal data for the same legitimate
            interests of our Business Partners.
            <br />- Legal compliance: We need to use and disclose personal data
            in certain ways to comply with our legal obligations.
            <br />‍<br />
            International Data Transfer
            <br />
            Our Services are operated primarily from the United States, and the
            recipients of the data disclosures described in this Privacy Policy
            are located in the United States and elsewhere in the world,
            including where privacy laws may not provide as much protection as
            the country in which you are located.&nbsp; We will comply with
            legal requirements for cross-border data protection, including
            (where applicable) through the use of European Commission-approved
            Standard Contractual Clauses or reliance on the third-party
            recipient’s participation in the EU-U.S. Privacy Shield Framework.
            <br />
            <br />
            <strong>Is Information About Me Secure?</strong>
            <br />
            We seek to protect Account information to ensure that it is kept
            private; however, we cannot guarantee the security of any Account
            information. We store all of our information, including your IP
            address and device information, using industry-standard techniques.
            We do not guarantee or warrant that such techniques will prevent
            unauthorized access to information about you that we store, Personal
            Information or otherwise.&nbsp; Unauthorized entry or use, hardware
            or software failure, and other factors may compromise the security
            of user information at any time.&nbsp; Additionally, you are
            responsible for preventing unauthorized access to your Account and
            Personal Information by protecting your Account credentials and
            limiting access to Service Device (as defined in the{" "}
            <a href="/terms-of-service">Terms of Service</a>
            ).
            <br />‍<br />
            <strong>How Can I Exercise My Data Protection Rights?</strong>
            <br />
            If you are a registered user, you can access and update certain
            information associated with your Account by logging in and visiting
            the profile or settings section.&nbsp; Any user can limit our use of
            their mobile device identifier by visiting the privacy settings of
            their mobile device as described further above.Residents of the
            European Economic Area (“EEA”) and certain other jurisdictions can
            contact us as described below to exercise other rights they have in
            relation to their Personal Information.&nbsp; For example, for those
            in the EEA, this includes certain rights to ask us to provide access
            to and/or a copy of certain Personal Information we hold about them
            (including, in certain cases, in a portable form)update Personal
            Information which is out of date or incorrect delete certain
            Personal Information which we are holding about them restrict the
            ways that we process certain of their Personal Information transfer
            certain Personal Information to a third party revoke consent for
            certain processing of Personal Information (which will not affect
            the lawfulness of Processing prior to when the revocation takes
            effect) or object to our processing of their information.
            <br />
            <br />
            For example, EEA residents have a right to opt out of our processing
            of their Personal Information for direct marketing purposes. We will
            consider all requests and provide our response within the time
            period stated by applicable law. Please note, however, that certain
            information may be exempt from such requests in some circumstances,
            which may include if we need to keep processing your information for
            our legitimate interests or to comply with a legal obligation. We
            may request you provide us with information necessary to confirm
            your identity before responding to your request.EEA residents and
            others also have a right to lodge a complaint with the relevant
            supervisory authority, but we invite you to raise any concerns with
            us first, and we will do our best to resolve them.
            <br />‍<br />
            California Privacy Rights:&nbsp;&nbsp;California law permits users
            who are California residents to request and obtain from us once a
            year, free of charge, a list of the third parties to whom we have
            disclosed their personal information (if any) for their direct
            marketing purposes in the prior calendar year, as well as the types
            of personal information disclosed to those parties.
            <br />
            <br />
            If you are a California resident and would like to request this
            information, please mail your request to VAULT, 100 Mamaroneck
            Avenue, Mamaroneck, New York 10543.
            <br />
            <br />
            <strong>How Can I Delete My Account?</strong>
            <br />
            Should you ever decide to delete your Account, you may do so through
            the App by deleting the App or by emailing support@vault.fan. If you
            terminate your Account, any association between your Account and
            information we store will no longer be accessible through your
            Account.
            <br />‍<br />
            <strong>What Choices Do I Have Regarding My Information?</strong>
            <br />
            You may, of course, decline to submit information through the
            Services, in which case we may not be able to provide certain
            services to you.
            <br />
            <br />
            You can delete your Account. Please note that we will need to verify
            that you have the authority to delete the Account.&nbsp; You can
            choose to opt out of certain communications or communication
            methods; however, if you do so, you may not be able to take
            advantage of some of our Services’ best features.&nbsp;&nbsp;
            <br />‍<br />
            <strong>
              What Happens When There Are Changes to this Privacy Policy?
            </strong>
            <br />
            If we change our privacy policies and procedures, we will post those
            changes on this page. If we make any changes to this Privacy Policy
            that materially change how we treat your personal information, we
            will endeavor to provide you with reasonable notice of such
            changes.&nbsp; We may do so via a prominent notice in the Service or
            to your email address of record, and where required by law, we will
            obtain your consent or give you the opportunity to opt out of such
            changes.
            <br />
            <br />
            <strong>What If I Have Questions or Concerns?</strong>
            <br />
            If you have any questions or concerns regarding privacy using the
            Services, please send us a detailed message to support@vault.fan. We
            will make every effort to resolve your concerns. We also can be
            reached as follows:
            <br />
            <br />
            VAULT <br />
            100 Mamaroneck Avenue
            <br />
            Mamaroneck, <br />
            NY 10543
            <br />
            <br />
            ‍Effective Date: 1st Nov, 2021
          </Text>
        </TextBlockWithTitle>
      </PageLayout>
    </>
  );
};

export default PrivacyPolicy;
